export default __webpack_public_path__ + "static/media/dog-lqMAX.jpg.d3f20905.txt";